import { CSSProperties } from 'react';

const styles: Record<string, CSSProperties> = {
  // Kept in step with ManageBox.style.ts and IdentityBox.tsx — the three sit
  // side by side in a Grid, so radius, padding and height have to match or the
  // row looks ragged. `height: 100%` fills the Grid cell; it was `auto` here,
  // which left this card visibly shorter than its neighbours.
  contactInfoBox: {
    width: '100%',
    height: '100%',
    padding: '16px',
    backgroundColor: 'white',
    borderRadius: '8px',
    border: '1px solid #e5e5e8',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    gap: '16px',
    direction: 'rtl',
    boxSizing: 'border-box',
  },
  contentBox: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: '16px',
  },
  sectionTitle: {
    alignSelf: 'stretch',
    textAlign: 'right',
    color: '#a6aab5',
    fontSize: '14px',
    fontFamily: 'IRANYekanXFaNum, sans-serif',
    fontWeight: 500,
    wordWrap: 'break-word',
  },
  infoSection: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: '8px',
    flexWrap: 'wrap',
  },
  infoItem: {
    flex: '1 1 0',
    height: 'auto',
    padding: '4px 0',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: '4px',
  },
  addressItem: {
    flex: '1 1 100%',
  },
  label: {
    textAlign: 'right',
    color: '#60646e',
    fontSize: '12px',
    fontFamily: 'IRANYekanXFaNum, sans-serif',
    fontWeight: 400,
    lineHeight: '20px',
    wordWrap: 'break-word',
  },
  value: {
    textAlign: 'right',
    color: '#1b1e24',
    fontSize: '14px',
    fontFamily: 'IRANYekanXFaNum, sans-serif',
    fontWeight: 500,
    lineHeight: '20px',
    wordWrap: 'break-word',
  },
};

export default styles;
